export default __webpack_public_path__ + "static/media/phone-black.28554676.png";